import React from 'react';
import {Link} from 'react-router-dom';
import karieLogo from '../../image/karie-logo.png';
import KarieLogoStyleWrapper from './karieLogo.style';

export default ({directTo}) => (
    <KarieLogoStyleWrapper className="isoLogo">
        <div className="isoLogoWrapper">
            <Link to={directTo} style={{display: "flex", alignItems: "center"}}>
                <img alt="" src={karieLogo} />
                <span style={{lineHeight: "30px", fontSize: "28px", padding: "5px 0 0 5px"}}>  Portal</span>
            </Link>
        </div>
    </KarieLogoStyleWrapper>
);
